import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from 'chart.js';

import { Pie } from 'react-chartjs-2';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title
);
const centerTextPlugin = {
    id: 'centerText',
    afterDraw(chart) {
        const { width, height, ctx } = chart;
        ctx.save();

        const dataset = chart.config.data.datasets[0];
        const text = dataset.data[0]?.toString() ?? '';

        ctx.fillStyle = '#333';
        const fontSize = height / 5;
        ctx.font = `${fontSize}px sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const textX = width / 2;
        const textY = height / 1.6;
        const rawValue = dataset.data[0];
        const displayText = (rawValue < 1) ? '0' : rawValue.toString();
        ctx.fillText(displayText, textX, textY);
        ctx.restore();
    }
};
export default function PieChartWithCenterValue(props) {
    return (
        <div style={{
            width: '100%',
            margin: 'auto',
            boxSizing: 'border-box',

        }}>
            <Pie
                data={props.data}
                options={{
                    ...props.options,
                    plugins: {
                        ...props.options?.plugins
                    }
                }}
                plugins={[centerTextPlugin]} // Register plugin locally
            />
        </div>
    );
}